export default {
  en: {
    apiLimitMessage: 'You might have reached free tier limit',
    pageLabel: 'Page',
    nextPageLabel: 'Next',
    previousPageLabel: 'Previous',
    citySearchInputPlaceholder: 'Type a city name',
    resultsPerPageLabel: 'results per page',
    englishVersion: 'English version',
    portugueseVersion: 'Portuguese version',
    deleteCityAction: 'Remove this item',
    deleteModalConfirmationTitle: 'Delete confirmation',
    deleteModalConfirmationMessage: 'Would you like to confirm the operation?',
    deleteModalConfirmationConfirmLabel: 'Delete',
    deleteModalConfirmationCancelLabel: 'Cancel',
    savedCityName: 'Name',
    savedCityWeather: 'Weather',
    savedCityMinTemperature: 'Min. Temp',
    savedCityMaxTemperature: 'Max. Temp',
  },
  'pt-BR': {
    apiLimitMessage: 'Limite da chamadas da camada gratuita atingido',
    pageLabel: 'Página',
    nextPageLabel: 'Próxima',
    previousPageLabel: 'Anterior',
    citySearchInputPlaceholder: 'Digite o nome da cidade',
    resultsPerPageLabel: 'resultados por página',
    englishVersion: 'Versão em inglês',
    portugueseVersion: 'Versão em português',
    deleteCityAction: 'Excluir',
    deleteModalConfirmationTitle: 'Confirmação de exclusão',
    deleteModalConfirmationMessage: 'Deseja confirmar a operação?',
    deleteModalConfirmationConfirmLabel: 'Excluir',
    deleteModalConfirmationCancelLabel: 'Cancelar',
    savedCityName: 'Nome',
    savedCityWeather: 'Clima',
    savedCityMinTemperature: 'Temp. Min',
    savedCityMaxTemperature: 'Temp. Max',
  },
};
